export default function useSessionComposable() {
  const workSpaceIdCookie = useCookie('c-wId')

  const workSpaceIdCookieExists = computed(() => {

    return workSpaceIdCookie.value !== undefined && workSpaceIdCookie.value !== null
  })
  const activeSession = computed(() => {

    if (!workSpaceIdCookieExists.value) return null
    try {
      console.log('workSpaceIdCookie.value', workSpaceIdCookie.value)
    }
    catch (e) {
      console.error('Failed to parse session cookie:', e)
      return null
    }
  })
  const showSelectWorkSpace = computed(() => {
    //  check if the link is starting with public then false
    const isPublicRoute = useRoute().path.startsWith('/public')
    if (isPublicRoute) {
      return false
    }
    else {
      if (!workSpaceIdCookieExists.value) {
        return true
      }
      else if (activeSession.value) {
        return false
      }
    }
  })

  return {
    session: activeSession,
    showSelectWorkSpace,
  }
}
